import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Role } from "./ProtectedRoute";
import { useRecoilValue } from "recoil";
import { authState } from "../recoil";
import { FiMenu } from "react-icons/fi";
import { IoClose } from "react-icons/io5";

interface ItemsListInterface {
  name: string;
  link: string;
  icon?: JSX.Element;
  role: Role;
}

export interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {
  list: ItemsListInterface[];
  className?: string;
  logo?: string;
  nameClass?: string;
  iconClass?: string;
}

export const Sidebar: React.FC<SidebarProps> = ({
  list,
  logo,
  nameClass,
  iconClass,
}) => {
  const auth = useRecoilValue(authState);
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="lg:hidden absolute top-0 left-0 flex gap-4 items-center justify-between px-6 py-4 z-0">
        <img src={logo} alt="logo" className="w-32" />
        <button
          onClick={() => setOpen(true)}
          className="text-2xl text-gray-700"
        >
          <FiMenu />
        </button>
      </div>

      <aside
        className={`
          fixed top-0 left-0 z-20 min-h-screen h-full w-64 bg-gray-50 shadow-lg
          transform transition-transform duration-300 ease-in-out
          ${open ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0 lg:static lg:block
        `}
        aria-label="Sidebar"
      >
        <div className="flex items-center justify-between px-4">
          <img src={logo} alt="logo" className="mx-auto my-6 w-[80%]" />
          <div className="lg:hidden flex justify-end p-4">
            <button
              onClick={() => setOpen(false)}
              className="text-2xl text-gray-700 bg-gray-300 rounded"
            >
              <IoClose />
            </button>
          </div>
        </div>

        <div className="py-4 px-3">
          <ul className="space-y-2">
            {list.map((item, index) =>
              item?.role === auth.role ? (
                <li key={index}>
                  <NavLink
                    to={item.link}
                    className={({ isActive }) =>
                      `flex items-center rounded-lg p-2 font-normal ${iconClass} ${
                        isActive ? "bg-primary/20" : ""
                      }`
                    }
                    onClick={() => setOpen(false)}
                  >
                    <span className="flex justify-center w-6">{item.icon}</span>
                    <span className={`ml-3 text-base ${nameClass}`}>
                      {item.name}
                    </span>
                  </NavLink>
                </li>
              ) : null
            )}
          </ul>
        </div>
      </aside>

      {open && (
        <div
          className="fixed inset-0 bg-black/50 lg:hidden z-10"
          onClick={() => setOpen(false)}
        />
      )}
    </>
  );
};
